/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_Token_SubtitleInputs */

const cs_auth_reset_token_subtitle = /** @type {(inputs: Auth_Reset_Token_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkaz platí jednou a vyprší za 30 minut. Poté se znovu přihlásíte.`)
};

const en_auth_reset_token_subtitle = /** @type {(inputs: Auth_Reset_Token_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link works once and expires in 30 minutes. You will sign in afterwards.`)
};

/**
* | output |
* | --- |
* | "This link works once and expires in 30 minutes. You will sign in afterwards." |
*
* @param {Auth_Reset_Token_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_reset_token_subtitle = /** @type {((inputs?: Auth_Reset_Token_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_Token_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_token_subtitle(inputs)
	return cs_auth_reset_token_subtitle(inputs)
});